<ng-container *transloco="let t; read: 'orders'">
  <div class="componentContainer">
    <section class="xs12col componentHeader">
      <h1>{{t('admin.title')}}</h1>
    </section>

    <section class="oneCol">
      <div class="xs12col">
        <div class="boxContainer">
          <div class="box">
            <h2 class="padding-bottom-medium">{{ t("admin.filterTitle")}}</h2>
            <form [formGroup]="filterForm" (submit)="onSubmitFilter()">
              <kendo-formfield>
                <kendo-label [for]="companyId" [text]="t('company')"></kendo-label>
                <kendo-dropdownlist
                  [data]="companies"
                  formControlName="companyId"
                  #companyId
                  [valuePrimitive]="false"
                  [kendoDropDownFilter]="filterSettings"
                  textField="name"
                  valueField="id">
                </kendo-dropdownlist>
              </kendo-formfield>

              <kendo-formfield>
                <kendo-label
                  [for]="internalNumber"
                  [text]="t('internalNumber')">
                </kendo-label>
                <kendo-textbox
                  formControlName="internalNumber"
                  #internalNumber>
                </kendo-textbox>
              </kendo-formfield>

              <kendo-formfield>
                <kendo-label [for]="orderState" [text]="t('orderState')"></kendo-label>
                <kendo-dropdownlist
                  [data]="orderStatesArray"
                  formControlName="orderState"
                  #orderState
                  [valuePrimitive]="false"
                  textField="name"
                  valueField="id">
                </kendo-dropdownlist>
              </kendo-formfield>

              <div class="buttonContainer">
                <button
                  kendoButton
                  class="buttonPrimary"
                  type="submit"
                  [disabled]="filterForm.invalid">
                  {{ t("filterSearch") }}
                </button>

                @if (showReset) {
                  <button
                    type="button"
                    (click)="onResetFilter()"
                    class="buttonSecondary">
                    {{ t("filterReset") }}
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="xs12col">
        <div class="boxContainer">
          <div class="box">
            <h2 class="padding-bottom-medium">{{ t("admin.orders")}}</h2>
            <app-order-grid
              [orders]="orders"
              [isAdminView]="true"
              (onReload)="onReload($event)"
              (onChangeOrderState)="onChangeOrderState($event)">
            </app-order-grid>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-container>
